"use strict";
const React = require('react');
const react_redux_1 = require('react-redux');
const Dialog_1 = require('material-ui/Dialog');
const FlatButton_1 = require('material-ui/FlatButton');
const IconButton_1 = require('material-ui/IconButton');
const TextField_1 = require('material-ui/TextField');
const Toggle_1 = require('material-ui/Toggle');
const close_1 = require('material-ui/svg-icons/navigation/close');
const react_router_1 = require('react-router');
const lodash_1 = require('lodash');
const tasks_1 = require('../actions/tasks');
const m = require('../models');
const selectors_1 = require('../selectors');
const DurationInput_1 = require('./DurationInput');
const Flex_1 = require('./Flex');
const GoalIcon_1 = require('./GoalIcon');
const Label_1 = require('./Label');
const Navigation_1 = require('./Navigation');
const RepeatSelect_1 = require('./RepeatSelect');
const Screen_1 = require('./Screen');
const c = require('./theme/colors');
const DEFAULT_GOAL_TYPE = 1 /* AT_LEAST */;
const mapStateToProps = (state, props) => ({
    task: selectors_1.taskSelector(state, props.params.taskId),
});
const mapDispatchToProps = (dispatch) => ({
    onCancel: () => {
        react_router_1.browserHistory.goBack();
    },
    onDeleteTask: (task) => {
        dispatch(tasks_1.deleteTask(task)).catch(e => console.error('error deleting task', e, task));
        react_router_1.browserHistory.goBack();
    },
    onSubmit: (task) => {
        dispatch(tasks_1.saveTask(selectors_1.viewTaskToTask(task))).catch(e => console.error('error saving task', e, task));
        react_router_1.browserHistory.goBack();
    },
});
class TaskScreen extends React.Component {
    constructor(props) {
        super(props);
        this.hasReceivedFetchedTask = () => !!this.props.task.id;
        this.buildStateFromProps = (props) => ({
            taskDraft: lodash_1.cloneDeep(props.task),
            lastEnabledGoalType: props.task.goal.type,
        });
        this.handleSave = (e) => {
            e.preventDefault();
            if (!this.hasReceivedFetchedTask) {
                return;
            }
            let duration = this.refs.duration.getMilliseconds();
            if (duration > m.GOAL_MAX_DURATION) {
                duration = this.props.task.goal.duration;
            }
            const task = Object.assign({}, this.props.task, {
                name: this.state.taskDraft.name || this.props.task.name,
                goal: Object.assign({}, this.props.task.goal, {
                    type: this.state.taskDraft.goal.type,
                    duration,
                    repeats: this.refs.repeat.getRepeats(),
                })
            });
            this.props.onSubmit(task);
        };
        this.openDeleteTaskDialog = () => this.setState({ isDeleteTaskDialogOpen: true });
        this.closeDeleteTaskDialog = () => this.setState({ isDeleteTaskDialogOpen: false });
        this.handleGoalToggle = (e, toggle) => {
            this.setGoalType(this.getNextGoalType(toggle));
        };
        this.state = Object.assign(this.buildStateFromProps(props), {
            isDeleteTaskDialogOpen: false,
        });
    }
    componentWillReceiveProps(nextProps) {
        this.setState(this.buildStateFromProps(nextProps));
    }
    getNextGoalType(toggle) {
        if (!toggle) {
            return 0 /* NONE */;
        }
        if (this.state.lastEnabledGoalType === 0 /* NONE */) {
            return DEFAULT_GOAL_TYPE;
        }
        return this.state.lastEnabledGoalType;
    }
    setTaskDraft(newDraft) {
        this.setState({ taskDraft: newDraft });
    }
    setName(name) {
        const newDraft = Object.assign({}, this.state.taskDraft, { name });
        this.setState({ taskDraft: newDraft });
    }
    setGoalType(type) {
        const taskDraft = this.state.taskDraft;
        const newDraft = Object.assign({}, taskDraft, {
            goal: Object.assign({}, taskDraft.goal, {
                type,
            }),
        });
        this.setState({
            lastEnabledGoalType: type === 0 /* NONE */ ? this.state.lastEnabledGoalType : type,
            taskDraft: newDraft,
        });
    }
    getErrorText(inputName, isValid) {
        if (!this.hasReceivedFetchedTask()) {
            return '';
        }
        if (!isValid) {
            return errorTexts[inputName];
        }
        return '';
    }
    render() {
        const task = this.state.taskDraft;
        const deleteTaskDialogActions = [
            React.createElement(FlatButton_1.default, {label: "Cancel", onTouchTap: this.closeDeleteTaskDialog}),
            React.createElement(FlatButton_1.default, {label: "Delete Task", primary: true, keyboardFocused: false, onTouchTap: () => this.props.onDeleteTask(task)}),
        ];
        const goalTypeNoneSelected = task.goal.type === 0 /* NONE */;
        const goalTypeAtLeastSelected = task.goal.type === 1 /* AT_LEAST */;
        const goalTypeAtMostSelected = task.goal.type === 2 /* AT_MOST */;
        const goalSectionStyle = Object.assign({}, style.formRow, {
            display: goalTypeNoneSelected ? 'none' : '',
        });
        const leftNavigationIcon = (React.createElement(IconButton_1.default, {onTouchTap: this.props.onCancel}, 
            React.createElement(close_1.default, {color: c.white})
        ));
        const rightNavigationIcon = (React.createElement(FlatButton_1.default, {label: "Save", onTouchTap: this.handleSave}));
        return (React.createElement(Screen_1.Screen, null, 
            React.createElement(Navigation_1.default, {leftIcon: leftNavigationIcon, rightIcon: rightNavigationIcon, title: task.name}), 
            React.createElement(Screen_1.ScreenContent, {style: style.screenContent}, 
                React.createElement("div", {style: style.formRow}, 
                    React.createElement(Label_1.default, {text: "Task name"}), 
                    React.createElement(TextField_1.default, {ref: "taskName", name: "taskName", value: task.name, fullWidth: true, errorText: this.getErrorText('taskName', !!task.name), onChange: e => this.setName(e.target.value)})), 
                React.createElement("div", {style: style.formRow}, 
                    React.createElement(Toggle_1.default, {ref: "goalToggle", label: "Goal", labelStyle: style.goalToggleLabel, toggled: goalTypeAtLeastSelected || goalTypeAtMostSelected, onToggle: this.handleGoalToggle})
                ), 
                React.createElement("div", {style: goalSectionStyle}, 
                    React.createElement(Flex_1.Row, null, 
                        React.createElement(FlatButton_1.default, {style: style.goalTypeButton, ref: "atMostButton", icon: GoalIcon_1.buildGoalIcon({ goalType: 1 /* AT_LEAST */, isSelected: goalTypeAtLeastSelected }), label: "At Least", primary: goalTypeAtLeastSelected, onTouchTap: () => this.setGoalType(1 /* AT_LEAST */)}), 
                        React.createElement(FlatButton_1.default, {style: style.goalTypeButton, ref: "atMostButton", icon: GoalIcon_1.buildGoalIcon({ goalType: 2 /* AT_MOST */, isSelected: goalTypeAtMostSelected }), label: "At Most", primary: goalTypeAtMostSelected, onTouchTap: () => this.setGoalType(2 /* AT_MOST */)}))
                ), 
                React.createElement("div", {style: goalSectionStyle}, 
                    React.createElement(Label_1.default, {text: "Duration", style: style.formLabel}), 
                    React.createElement(DurationInput_1.default, {ref: "duration", defaultDuration: task.goal.duration, disabled: task.goal.type === 0 /* NONE */})), 
                React.createElement("div", {style: goalSectionStyle}, 
                    React.createElement(Label_1.default, {text: "Repeats On", style: Object.assign({}, style.formLabel, { marginBottom: '18px' })}), 
                    React.createElement(RepeatSelect_1.default, {ref: "repeat", repeats: task.goal.repeats, disabled: task.goal.type === 0 /* NONE */})), 
                React.createElement("div", {style: style.deleteTaskFormRow}, 
                    React.createElement(FlatButton_1.default, {style: style.deleteTaskButton, label: "Delete Task", secondary: true, onTouchTap: this.openDeleteTaskDialog})
                )), 
            React.createElement(Dialog_1.default, {title: "Delete task", actions: deleteTaskDialogActions, open: this.state.isDeleteTaskDialogOpen, onRequestClose: this.closeDeleteTaskDialog}, "Are you sure you want to delete this task? All task data will be lost.")));
    }
}
exports.TaskScreen = TaskScreen;
const style = {
    screenContent: {
        // Hack: prevent grey overlay present when keyboard is active from obscuring
        // the input field.
        paddingBottom: '75vh',
    },
    formRow: {
        margin: '18px 0',
    },
    deleteTaskFormRow: {
        margin: '18px auto',
    },
    formLabel: {
        display: 'block',
        marginBottom: '4px',
    },
    goalToggleLabel: {
        fontSize: '14px',
        color: c.whiteTransparent,
    },
    goalTypeButton: {
        flex: 1,
    },
    deleteTaskButton: {
        flex: 1,
    },
};
const errorTexts = {
    taskName: 'Please, give me a name!',
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(TaskScreen);



/** WEBPACK FOOTER **
 ** ./src/components/TaskScreen.tsx
 **/